





























import Vue from "vue";
import InputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";


export default Vue.extend({
    components: {
        InputNumber: InputNumber,
        iwTooltip: iwTooltip,
    },
    data: function() {
        return {
            pathInStore: "property.land.surface",
            inputName: "land-area",
            specificId: uuidv4() as string
        };
    },
    computed: {
        landArea: function(): string|null {
            const lArea = this.$store.getters["FormModule/getValue"](this.pathInStore);
            if(lArea) {
                return lArea;
            }
            return "";
        },
        getErrorMessage: function(): string|null {
            return this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStore);
        },
        isDisplayed: function(): boolean {
            const allowedPropertyTypes = [
                "HOUSE",
                "OFFICE",
                "INDUSTRY",
                "COMMERCIAL",
                "LAND",
                "OTHER",
            ];

            const isForSale =
                this.$store.getters["FormModule/getValue"]("transaction.type") === "FOR_SALE";

            return (
                isForSale &&
                allowedPropertyTypes.includes(this.getPropertyType())
            );
        },
        isOptional: function(): boolean {
            return ["HOUSE", "LAND"].indexOf(this.getPropertyType()) === -1;
        }
    },
    mounted: function() {
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(landArea: number): void {
            if (landArea == 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": landArea});
            }
        }
    }
});

